module.exports = __webpack_public_path__ + "static/img/third13.00640e14.png";